import axios from "api/config/axiosConfig";
import { DesignTemplate } from "./config/chalice-types";

export const fetchTemplates = async (params: {
  enabled: boolean;
}): Promise<DesignTemplate[]> => {
  return (await axios.get("/templates", { params })).data.templates;
};
